import { createContext, useContext } from "react";

/**
 * Identifies the top-of-section element where RightSideWrapper renders its
 * contextual card.
 */
export const RightSidePortalContext = createContext<string | undefined>(undefined);

export const useRightSidePortal = () => useContext(RightSidePortalContext);
